import React from 'react'
    
export const CurrencyIqFormat = ({val=0}) => {
    return (
        new Intl.NumberFormat().format(val)
    )
}